// Array.from(range(1, 3)) => [1, 2, 3]
// @param {Any} from
// @param {Any} to
// @param {(Any) => Any} next
// @return {Iterable<Any>}
export function* range (from, to, next = v => v + 1) {
  let value = from
  while (true) {
    yield value
    value = next(value)
    if (value > to) break
  }
}

// @param {Iterable<Any>} iterable
// @return {Array<Any>}
export function unique (iterable) {
  return Array.from(new Set(iterable))
}

// @param {Array<Any>} array
// @return Any
export function last (array) {
  return array[array.length - 1]
}

// Stable sort
// @param {Iterable<Any>} iterable
// @param {(Any, Any) => Number} comparator
// @return {Array<Any>}
const NumberComparator = (a, b) => {
  if (a > b) return 1
  else if (b > a) return -1
  return 0
}
export function sort (iterable, comparator = NumberComparator) {
  return Array.from(iterable).sort(comparator)
}

// [1, 2, 3, 5, 6, 7] => [[1, 2, 3], [5, 6, 7]]
// @param {Iterable<Any>} iterable
// @param {(Any) => Any} next
// @return {Array<Array<Any>>}
export function groupByContinuousValues (iterable, next = v => v + 1) {
  return sort(iterable)
    .reduce((ranges, value) => {
      if (ranges.length === 0) {
        ranges.push([value])
      } else if (next(last(last(ranges))) === value) {
        last(ranges).push(value)
      } else {
        ranges.push([value])
      }
      return ranges
    }, [])
}

export default { range, unique, last, sort, groupByContinuousValues }



// WEBPACK FOOTER //
// ./src/libs/collection-utility.js